module.exports = __webpack_public_path__ + "static/worley_bleed-9f217b2ab0d14106c10a6c6878bc9f00.gif";